import { classificationResultCalculation } from "../../../patient/clinical-services/service-steps/treatment/data";
import * as icons from "./icons";
import {
  paediatricPrescriptionOralAntihistamines,
  adultPrescriptionOralAntihistamines,
  paediatricNonPrescriptionOralAntihistamines,
  adultNonPrescriptionOralAntihistamines,
  adultPrescriptionIntranasalCorticosteroids,
  paediatricPrescriptionIntranasalCorticosteroids,
  adultPrescriptionCombination,
  paediatricPrescriptionCombination,
  adultPrescriptionAddOnOralDecongestants,
  paediatricPrescriptionAddOnOralDecongestants,
  adultPrescriptionAddOnIntranasalDecongestants,
  paediatricPrescriptionAddOnIntranasalDecongestants,
} from "../../../patient/clinical-services/service-steps/treatment/pharmacological/data";
import { capitalizeFirstLetter } from "../../../../helpers/functions";

export const treatmentTypes = {
  PharmacologicalOralTherapy: 1,
  PharmacologicalIntranasalTherapy: 2,
  PharmacologicalAddOn: 3,
  NonPharmacological: 4,
};

const medicationContent = {
  oralAntihistamine: {
    howItWorks: {
      label: "Relieves 4 Symptoms:",
      listItems: [
        "Sneezing",
        "Runny nose (clear colour)",
        "Itchy nose",
        "Itchy or watery eyes",
      ],
      icon: icons.pillsIcon,
    },
    howToTake: {
      listItems: [
        "Take the medication at the same time each day",
        "Works best if taken every day",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Usually works between 30 minutes to 2 hours",
        "Provides relief of allergy symptoms",
      ],
      icon: icons.pillBottleIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "Monitor for drowsiness",
        "If Drowsy, take medication at bedtime or call your Pharmacist",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
  intranasalCorticosteroids: {
    howItWorks: {
      label: "Relieves 4 Symptoms",
      listItems: [
        "Nasal itching",
        "Nasal congestion",
        "Runny nose",
        "Sneezing",
      ],
      icon: icons.nasalSprayIcon,
    },
    howToTake: {
      listItems: [
        "Blow your nose to clear your nostrils",
        "Shake and prime the bottle if unused or inactive for over 7 days",
        "Aim the spray away from the septum",
        "Spray the medicine into one nostril at a time",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Symptom relief occurs within 1 to 2 days",
        "Full benefits may take up to 2 weeks to show symptom improvement",
        "Relieves allergy symptoms",
      ],
      icon: icons.gearsIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "To manage irritation try a different spray or a moisturizing nasal gel",
        "Manage nosebleeds by aiming spray away from septum or use a nasal gel",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
  addOnTherapy: {
    howItWorks: {
      label: "Prevents allergy symptoms:",
      listItems: [
        "Sneezing",
        "Runny nose (clear colour)",
        "Itchy nose",
        "Itchy ir waterky eyes",
      ],
      icon: icons.pillsIcon,
    },
    howToTake: {
      listItems: [
        "Take the medication at the same time each day",
        "Works best if taken every day",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Usually works between 30 minutes to 2 hours",
        "Provides relief of allergy symptoms",
      ],
      icon: icons.pillBottleIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "Monitor for drownsiness",
        "If Drowsy, take medication at bedtime or call your Pharmacist",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
  combination: {
    howItWorks: {
      label: "Relieves 4 Symptoms:",
      listItems: [
        "Sneezing",
        "Runny nose (clear colour)",
        "Itchy nose",
        "Itchy or watery eyes",
      ],
      icon: icons.pillsIcon,
    },
    howToTake: {
      listItems: [
        "Take the medication at the same time each day",
        "Works best if taken every day",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Usually works between 30 minutes to 2 hours",
        "Provides relief of allergy symptoms",
      ],
      icon: icons.pillBottleIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "Monitor for drowsiness",
        "If Drowsy, take medication at bedtime or call your Pharmacist",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
  salineRinse: {
    howItWorks: {
      listItems: [
        "Provides relief from congestion",
        "Washes out nasal mucus and allergens",
        "Adds moisture & relieves dryness",
        "Helps to prevent nosebleeds",
      ],
      icon: icons.nasalRinseIcon,
    },
    howToTake: {
      listItems: [
        "Squeeze the saline solution slowly into one nostril at a time",
        "Allow solution to pour out from the other nostril",
        "Breathe through your mouth",
        "Use distilled, boiled, or cooled water",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Less nasal stuffiness",
        "Feels easier to breathe",
        "Less congestion",
        "Mucus is easier to remove from nose ",
      ],
      icon: icons.gearsIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "Change the temperature of the water",
        "Use less Nasal Rinse Solution with the water",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
  salineSpray: {
    howItWorks: {
      listItems: [
        "Provides relief from congestion",
        "Washes out nasal mucus and allergens",
        "Adds moisture & relieves dryness",
        "Helps to prevent nosebleeds",
      ],
      icon: icons.nasalSprayIcon,
    },
    howToTake: {
      listItems: [
        "Squeeze the saline solution slowly into one nostril at a time",
        "Allow solution to pour out from the other nostril",
        "Breathe through your mouth",
        "Use distilled, boiled, or cooled water",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Less nasal stuffiness",
        "Feels easier to breathe",
        "Less congestion",
        "Mucus is easier to remove from nose ",
      ],
      icon: icons.gearsIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "Change the temperature of the water",
        "Use less Nasal Rinse Solution with the water",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
  nasalLubricant: {
    howItWorks: {
      listItems: [
        "Provides relief from congestion",
        "Washes out nasal mucus and allergens",
        "Adds moisture & relieves dryness",
        "Helps to prevent nosebleeds",
      ],
      icon: icons.nasalRinseIcon,
    },
    howToTake: {
      listItems: [
        "Squeeze the saline solution slowly into one nostril at a time",
        "Allow solution to pour out from the other nostril",
        "Breathe through your mouth",
        "Use distilled, boiled, or cooled water",
      ],
      icon: icons.rxIcon,
    },
    howToKnowItsWorking: {
      listItems: [
        "Less nasal stuffiness",
        "Feels easier to breathe",
        "Less congestion",
        "Mucus is easier to remove from nose ",
      ],
      icon: icons.gearsIcon,
    },
    howToManageSideEffects: {
      listItems: [
        "Change the temperature of the water",
        "Use less Nasal Rinse Solution with the water",
        "If symptoms do not improve or any new symptoms appear, see your healthcare provider.",
      ],
      icon: icons.plusIcon,
    },
  },
};

export function getMedicationList(treatment) {
  if (!treatment) return [];

  const { frequencyOfSymptoms, levelOfSeverity } = treatment;
  const classification = classificationResultCalculation(
    frequencyOfSymptoms,
    levelOfSeverity
  );

  // Function to find medication name from medicationGenCode
  const getMedicationNameStr = (p) => {
    if (!p?.medicationGenCode) {
      return p?.medicationName || "n/a";
    }

    // Array of all medication data objects to search through
    const medicationDataObjects = [
      paediatricPrescriptionOralAntihistamines,
      adultPrescriptionOralAntihistamines,
      paediatricNonPrescriptionOralAntihistamines,
      adultNonPrescriptionOralAntihistamines,
      adultPrescriptionIntranasalCorticosteroids,
      paediatricPrescriptionIntranasalCorticosteroids,
      adultPrescriptionCombination,
      paediatricPrescriptionCombination,
      adultPrescriptionAddOnOralDecongestants,
      paediatricPrescriptionAddOnOralDecongestants,
      adultPrescriptionAddOnIntranasalDecongestants,
      paediatricPrescriptionAddOnIntranasalDecongestants,
    ];

    // Search through all medication data objects
    for (const medicationData of medicationDataObjects) {
      if (!medicationData?.medications) continue;

      // Search through each medication
      for (const medication of medicationData.medications) {
        if (!medication?.dosages) continue;

        // Search through each dosage
        for (const dosage of medication.dosages) {
          if (dosage?.medicine?.identifier === p.medicationGenCode) {
            // Return the medication name, optionally with dose if available
            return medication.name + " " + capitalizeFirstLetter(p?.form);
          }
        }
      }
    }

    // Fallback to medicationName if not found in data
    return p?.medicationName || "n/a";
  };

  const getDosageStr = (p) =>
    p?.medicationName
      ? `${p?.medicationName} ${
          p?.medicationGenCodeType !== "Sentence"
            ? `${p?.frequency} ${p?.form} ${p?.route} `
            : ""
        }`
      : "n/a";

  const firstLineTherapyPrescriptions = treatment.firstLineTherapyPrescriptions
    ?.length
    ? treatment.firstLineTherapyPrescriptions.map((p) =>
        classification === "Mild Intermittent"
          ? {
              type: treatmentTypes.PharmacologicalOralTherapy,
              label: "First Line Therapy: Oral Antihistamine",
              dosage: getMedicationNameStr(p),
              instruction: p?.comments,
              content: medicationContent.oralAntihistamine,
              sig: p?.sig,
            }
          : {
              type: treatmentTypes.PharmacologicalOralTherapy,
              label: "First Line Therapy: Intranasal Corticosteroids",
              dosage: getMedicationNameStr(p),
              instruction: p?.comments,
              content: medicationContent.intranasalCorticosteroids,
              sig: p?.sig,
            }
      )
    : [];

  const stepUpTherapyPrescriptions = treatment.stepUpTherapyPrescriptions
    ?.length
    ? treatment.stepUpTherapyPrescriptions.map((p) =>
        classification === "Mild Intermittent"
          ? {
              type: treatmentTypes.PharmacologicalIntranasalTherapy,
              label: "Step Up Therapy: Intranasal Corticosteroids",
              dosage: getMedicationNameStr(p),
              instruction: p?.comments,
              content: medicationContent.intranasalCorticosteroids,
              sig: p?.sig,
            }
          : {
              type: treatmentTypes.PharmacologicalIntranasalTherapy,
              label:
                "Step Up Therapy: Intranasal Corticosteroids/Antihistamine",
              dosage: getMedicationNameStr(p),
              instruction: p?.comments,
              content: medicationContent.combination,
              sig: p?.sig,
            }
      )
    : [];

  const alternativeFirstLineTherapyPrescriptions = treatment
    .alternativeFirstLineTherapyPrescriptions?.length
    ? treatment.alternativeFirstLineTherapyPrescriptions.map((p) => ({
        type: treatmentTypes.PharmacologicalIntranasalTherapy,
        label:
          "Alternative First Line Therapy: Intranasal Corticosteroids/Antihistamine",
        dosage: getMedicationNameStr(p),
        instruction: p?.comments,
        content: medicationContent.combination,
        sig: p?.sig,
      }))
    : [];

  const addOnTherapyOralDecongestantsPrescriptions = treatment
    .addOnTherapyOralDecongestantsPrescriptions?.length
    ? treatment.addOnTherapyOralDecongestantsPrescriptions.map((p) => ({
        type: treatmentTypes.PharmacologicalAddOn,
        label: "Add-on Therapy: Oral Decongestants",
        dosage: getMedicationNameStr(p),
        instruction: p?.comments,
        content: medicationContent.addOnTherapy,
        sig: p?.sig,
      }))
    : [];

  const addOnTherapyIntranasalDecongestantsPrescriptions = treatment
    .addOnTherapyIntranasalDecongestantsPrescriptions?.length
    ? treatment.addOnTherapyIntranasalDecongestantsPrescriptions.map((p) => ({
        type: treatmentTypes.PharmacologicalAddOn,
        label: "Add-on Therapy: Intranasal Decongestants",
        dosage: getMedicationNameStr(p),
        instruction: p?.comments,
        content: medicationContent.addOnTherapy,
        sig: p?.sig,
      }))
    : [];

  const addOnTherapyOralAntihistaminesPrescriptions = treatment
    .addOnTherapyOralAntihistaminesPrescriptions?.length
    ? treatment.addOnTherapyOralAntihistaminesPrescriptions.map((p) => ({
        type: treatmentTypes.PharmacologicalAddOn,
        label: "Add-on Therapy: Oral Antihistamines",
        dosage: getMedicationNameStr(p),
        instruction: p?.comments,
        content: medicationContent.addOnTherapy,
        sig: p?.sig,
      }))
    : [];

  const nasalSalineRinsePrescriptions = treatment.nasalSalineRinsePrescriptions
    ?.length
    ? treatment.nasalSalineRinsePrescriptions.map((p) => ({
        type: treatmentTypes.NonPharmacological,
        label: "Non-Pharmacological Treatment: Nasal Saline Rinses",
        dosage: null,
        instruction: p?.comments,
        content: medicationContent.salineRinse,
        sig: p?.sig,
      }))
    : [];

  const nasalSalineSprayPrescriptions = treatment.nasalSalineSprayPrescriptions
    ?.length
    ? treatment.nasalSalineSprayPrescriptions.map((p) => ({
        type: treatmentTypes.NonPharmacological,
        label: "Non-Pharmacological Treatment: Nasal Saline Sprays/Drops",
        dosage: null,
        instruction: p?.comments,
        content: medicationContent.salineSpray,
        sig: p?.sig,
      }))
    : [];

  const nasalLubricantPrescriptions = treatment.nasalLubricantPrescriptions
    ?.length
    ? treatment.nasalLubricantPrescriptions.map((p) => ({
        type: treatmentTypes.NonPharmacological,
        label: "Non-Pharmacological Treatment: Nasal Lubricants/Gel",
        dosage: null,
        instruction: p?.comments,
        content: medicationContent.nasalLubricant,
        sig: p?.sig,
      }))
    : [];

  return [
    ...firstLineTherapyPrescriptions,
    ...stepUpTherapyPrescriptions,
    ...alternativeFirstLineTherapyPrescriptions,
    ...nasalSalineRinsePrescriptions,
    ...nasalSalineSprayPrescriptions,
    ...nasalLubricantPrescriptions,
    ...addOnTherapyOralDecongestantsPrescriptions,
    ...addOnTherapyIntranasalDecongestantsPrescriptions,
    ...addOnTherapyOralAntihistaminesPrescriptions,
  ];
}
